import styled from 'styled-components';
import { Modal } from 'react-bootstrap';
const darkenColor = (hex, amount = 40) => {
  const num = parseInt((hex || '#BE7D9C').replace('#', ''), 16);
  const r = Math.max(0, (num >> 16) - amount);
  const g = Math.max(0, ((num >> 8) & 0xff) - amount);
  const b = Math.max(0, (num & 0xff) - amount);
  return `#${[r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')}`;
};


const NoInitiativeCard = styled.div`
  width: 100%;
  height:200px;
  display:flex;
  background:#F2F5FB;
  border: 0.75px solid #D3DEF2;
  border-radius:6px;
  padding: 26px  16px 26px 55px;
  margin-top: 20px;
  .image{
    width:196px;
    height:148px;
    >img{
        width:100%;
        height:100%;
    }
  }

  .buttonContent{
       display:flex;
       align-items:center;
       justify-content:center;
     }


  .details{
    display:block;
    margin:auto;
    ${'' /* padding-left:72px; */}
    .title{
      color: #184A61;
      font-family: Lato;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      margin-top:8px;
      display:flex;
      align-items:center;
    }
    .subtext{
      color: #184A61;
      width:533px;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-top:8px;
    }


   


    .button{
      margin:auto;
      border-radius: 6px;
      >button{
        width:100%;
      }
    }
  }
`;

const CommonButton = styled.div`
display:flex;
cursor:pointer;
align-items:center;
justify-content:center;
background-color:${(props) =>props.disabled?"#EFEFEF": props.backgroundColor?props.backgroundColor:"#F37A65"};
color:${(props) => props.disabled?"#989898": props.color?props.color:"#FEFEFE"};
border-radius: 4px;
padding: ${(props) => props.padding?props.padding:"12px 16px"};
outline:none;
border:none;
font-size:16px;
line-height:20px;
font-family:lato;
width:${(props) =>  props.width?props.width:"100%"};
.icon{
  margin-right:8px;
  display:flex;
}
`;

const Heading = styled.div`
width:100%;
display:flex;
background:rgba(254, 254, 254, 0.60);
padding: 16px 20px;
border-radius:4px;
.icon{
  margin-right:16px;
  display: flex;
  align-items: center;
  cursor:pointer;
}
color: #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
`;

const InitiativesWrap = styled.div`
width:100%;
display:flex;
padding: 4px 0px 8px 0px;
${'' /* background: #FEFEFE99; */}
flex-wrap:wrap;
${'' /* margin-top:20px; */}
border-radius:4px;
margin-bottom:50px;
.title{
  color: #184A61;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  width:100%;
}
.border{
  width:100%;
  height:1px;
  display:flex;
  background:#EFEFEF;
  margin: 20px 0;
  border: none !important;
}
.border-card{
  width:100%;
  height:1px;
  display:flex;
  background:#EFEFEF;
}
.details{
  display:flex;
  flex-wrap:wrap;
  gap:12px;
  .initiative-card{
    width: 398px;
    border: 1px solid #DCDCDC;
    background: #ffffff;
    border-radius: 8px;
  }
  ${'' /* .initiative-card:nth-child(1),.initiative-card:nth-child(2) {
    width: 400px !important;
  } */}
  .initiative-cards{
    width:auto;
  }
  .initiative-row{
    display: flex;
    width: 100%;
    gap: 8px;
  }
  .initiative-row-completed{
    display: flex;
    width: 100%;
    gap: 8px;
    flex-wrap:wrap;
  }
}
`;

const InitiativeCard = styled.div`
display:flex;
width:100%;
padding: 8px 20px 8px 8px;
background: #ffffff;
border-radius:8px;
.icon{
  width:48px;
  height:48px;
  display:flex;
  background: ${(props) => props.background?props.background:"#BE7D9C"};
  justify-content:center;
  align-items:center;
  border-radius:50%;
  >img{
    width:24px;
    height:24px;
  }
} 
.initiative-title{
  color: #005C87;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-left: 12px;
  align-items: center;
  display: flex;
}
.wrap-content{
  display:flex;
  width:275px;
  flex-wrap:wrap;
  align-items:center;
  margin-left: 12px;
  .title{
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #005C87;
    display:flex;
    width:100%;
    align-items:center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display:block;
  }
  .completed{
    font-family: Lato;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
    color:#BDBDBD;
    display:flex;
    width:100%;
    align-items:center;
    margin-top:8px;
  }
}
.count{
  display:flex;
  margin: auto 0px auto auto;
}
.end-container{
  display:flex;
  margin: auto 0px auto auto;
  cursor:pointer;
}
`;

const CheckMarkCount = styled.div`
display:flex;
width:20px;
height:20px;
border: ${(props) => props.active?"none":"1px solid #7C7C7C"};
background: ${(props) => props.active?"#F37A65":"none"};
text-align: center;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 20px;
color: #EFEFEF;
justify-content:center;
align-items:center;
border-radius:4px;
cursor:pointer;

`;

const HoverBackground = styled.div`
	position: absolute;
  width: ${({width}) => width ? '394px' : '288px'};
  height: ${({height}) => height ? 'height' : '196px'};
	background-color: rgba(0, 0, 0, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	z-index: 2;
	.view-button {
		font-family: Lato;
		font-size: 16px;
		line-height: 20px;
		min-width: 160px;
		width: 200px;
		height: 40px;
		background: #F37A65;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		border-radius: 4px;
		color: #FEFEFE;
		text-align: center;
		padding: 12px 20px 12px 20px;
	}
`

const HdmTopCard = styled.div`
width: ${({width}) => width ? 'calc((100% - 64px)/3)' : 'calc((100% - 96px)/4)'};
max-width: ${({width}) => width ? '396px' : '288px'};
background:white;
border-radius:6px;
display:flex;
justify-content:center;
display:flex;
flex-wrap: wrap;
.div-wrap{
  display:block;
  width:100%;
  height: ${({isCardHeight}) => isCardHeight ? isCardHeight : ''};
  padding:12px;
  .deleteButton{
    display:flex;
    ${'' /* width:100%; */}
    justify-content:center;
    margin:20px 0;
    .icon{
      cursor:pointer;
    }

  }
.image{
  width:100%;
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto auto 12px auto;
  border-radius:50%;
  background: ${({background}) => background ? background : '#F56E8F'};
  >img{
    width:24px;
    height:24px;
  }
}
.title{
  color: #184A61;
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  width:100%;
  align-items:center;
  display:flex;
  justify-content:center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display:block;
}
.value{
  width:100%;
  align-items:center;
  display:flex;
  color: #184A61;
  font-family: Lato;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 68px;
  justify-content:center;
}
.percent-user{
  color: #184A61;
  text-align: center;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  width:100%;
  align-items:center;
  display:flex;
  justify-content:center;
}
.button-launch{
  padding: 0 36px;
  margin-top:24px;
  justify-content: center;
  display: flex;
  >button{
    width:200px;
  }
}
}
`;



const NewScheduledCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .daysText{
    color: var(--Earthy-Orange-700, #C06236);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  > div {
    width: calc((100% - 32px) / 3);
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 6px;
    height: 94%;
  }

  > div:nth-child(3n) {
    margin-right: 0;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media(max-width: 900px) {
    > div {
      width: calc((100% - 16px) / 2);
      margin-right: 16px;
    }
    > div:nth-child(3n) {
      margin-right: 16px;
    }
    > div:nth-child(2n) {
      margin-right: 0;
    }
    > div:last-child {
      margin-right: 0;
    }
  }

  @media(max-width: 600px) {
    > div {
      width: 100%;
      margin-right: 0;
    }
  }
`;

const InitiativeImageContainer = styled.div`
   display: flex;
   width: 48px;
   height: 48px;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   gap: 4px;
   border-radius: 40px;
   border: 0.75px solid var(--Golden-Olive-500, #B1AA56);
   background: var(--Golden-Olive-100, #F5F6E8);
   `;
   




const HeaderPopup = styled.div`
display:flex;
width:100%;
padding: ${({padding}) => padding ? padding : '16px'};
.title{
  color: #184A61;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.closeIcon{
  display:flex;
  margin: auto 0px auto auto;
  cursor:pointer;
}
`;

const StyledModal = styled(Modal)`

	.modal-dialog{
		display: flex;
    justify-content: center;
    transform: ${({ transform }) => transform && 'translate(0, 80px) translate(0, -90%) !important'};
		.modal-content{
      width: ${({ newWidth }) => newWidth ? newWidth : '100%'};
      ${'' /* height: auto; */}
      height: ${({ newHeight }) => newHeight ? newHeight : 'auto'};
      box-shadow: none;
      position: absolute;
      border-radius: 10px;
	  }
  @media (max-width: 500px) and (min-width: 320px) {
    .modal-dialog {
			width: 100%;
    }
  }
  .border-top{
    height:1px;
    width:100%;
    display:flex;
    background: #EFEFEF;
    border: none;
  }
`;

const StyledModalBody = styled(Modal.Body)`
display:flex;
flex-wrap:wrap;
width:100%;
padding: 8px  16px 20px !important;
.button-wrapper{
  width:100%;
  display:flex;
  justify-content:center;
}
.popup-title{
  display:flex;
  width:100%;
  .icon{
    width:48px;
    height:48px;
    >img{
      width:30px;
      height:30px;
    }
  }
  .wrap{
    display:flex;
    flex-wrap:wrap;
    width:350px;
    align-items: center;
    margin-left:12px;
    .initiative{
      color: #184A61;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width:100%;
      align-items:center;
      display:flex;
    }
    .active{
      color: #BDBDBD;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width:100%;
      align-items:center;
      display:flex;
    }
  }
  .download{
    display:flex;
    margin: auto 2px auto auto;
    cursor:pointer;
  }
}
.percentage-wrap{
  display:flex;
  width:100%;
  margin-top:28px;
  .usercomplete{
    color:  #184A61;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    align-items:center;
    display:flex;
  }
  .percentage{
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    align-items:center;
    display:flex;
    margin: auto 0 auto auto;
  }
}
.progress{
  display:flex;
  width:100%;
  margin-top:12px;
  height:32px;
  background: none;
}
.border-line{
  height:1px;
  width:100%;
  display:flex;
  background: #EFEFEF;
  margin: 24px 0;
}

.date-wrap{
  display:flex;
  width:100%;
  .first-date{
    display:flex;
    width:50%;
    justify-content:flex-start;
    flex-wrap: wrap;
    .date{
      color: #184A61;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      align-items:center;
      display:flex;
      width:100%;
    }
    .value{
      color: #184A61;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      align-items:center;
      display:flex;
      width:100%;
      margin-top:4px;
    }
  }
  .end-date{
    display:flex;
    width:50%;
    justify-content:flex-end;
    flex-wrap: wrap;
    .date{
      color: #184A61;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      align-items:center;
      display:flex;
      width:100%;
      justify-content: end;
    }
    .value{
      color: #184A61;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      align-items:center;
      display:flex;
      width:100%;
      justify-content: end;
      margin-top:4px;
    }
  }
}



.active-text{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  text-align: center;
  /* Primary - Lato/Body-Text */
  margin: 20px auto auto auto;
  font-family: Lato;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
}
`;

const ParticipantsHeader = styled.div`
width:100%;
display:flex;
.initiative-wrap{
  ${'' /* width:200px; */}
  width: ${({isWidth}) => isWidth ? isWidth : '200px'};
  display:flex;
  flex-wrap:wrap;
  margin-left: 12px;
  gap: 8px;
  .initiative{
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #184A61;
    display:flex;
    width:100%;
  }
  .completed{
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #184A61;
    display:flex;
    width:100%;
  }
  .date{
    font-family: Lato;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #BDBDBD;
    display:flex;
    width:100%;
  }
}
.count{
  font-family: Lato;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  vertical-align: middle;
  color:#184A61;
  display:flex;
  align-items:center;
  margin: auto 16px auto auto;
}

.active-count{
  color: var(--Font-Color-on-Dark-theme-200, #BDBDBD);
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}



`;

const ScrollWrapper = styled.div`
display:flex;
flex-wrap:wrap;
height: ${({height}) => height ? height : ''};
overflow-y: ${({scroll}) => scroll ? 'scroll' : ''}  ;
gap: 4px;
margin-top: ${({margin}) => margin ? margin : '16px'}  ;
width:100%;
  ::-webkit-scrollbar {
    width: 5px;
    height: 45px;
  }
  ::-webkit-scrollbar-thumb {
    background: #c6c2c2;
    cursor: pointer;
    border-radius: 2.5px;
  }

  ::-webkit-scrollbar-track {
    background: #f2f0f0;
    border-radius: 2.5px;
  }
`;

const ParticipantCard = styled.div`
width:100%;
display:flex;
padding: 8px 16px 8px 8px;
.profile{
  width:48px;
  height:48px;
  display:flex;
  border-radius:50%;
  margin-right:12px;
  >img{
    width:100%;
    height:100%;
    border-radius:50%;
  }
}
.name{
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #184A61;
  display:flex;
  align-items:center;
}
.date{
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #184A61;
  display:flex;
  align-items:center;
  margin: auto 0 auto auto;
}
`;
// Delete confirmation modal styles
const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalCard = styled.div`
  width: 420px;
  max-width: 92vw;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  overflow: hidden;
`;

const ModalHeader = styled.div`
  padding: 14px 18px;
  color: #184A61;
  font-weight: 700;
  font-size: 18px;
  display: block;
  align-items: center;
  justify-content: space-between;

  .close {
    cursor: pointer;
    color: #F37A65;
    font-size: 25px;
    line-height: 1;
    float: right;
    font-weight: 100;
  }
  .name {
    font-size: 16px;
    font-weight: 400;
    padding-top: 10px;
    color:#184A61;
    
  }
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(0, 92, 135, 0.10);
  margin: 0 15px;
`;

const ModalBody = styled.div`
  padding: 16px 18px 18px 18px;
  color: #184A61;
  font-size: 16px;
  text-align:center;

  .name {
    font-size: 16px;
    font-weight: 400;
    padding-top: 10px;
    color:#184A61;
    
  }
`;


const InitiativeGraph = styled.div`
  display: flex;
  width:564px;
  height:164px;
  align-items: center;
  gap: 20px;
  margin-bottom: 12px;


  .heading{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 700;
   line-height: 20px;
   margin-bottom: 16px;
  }

  .lastHeading{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 700;
   line-height: 20px;
  }

  .sub-heading{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }



  `;





const ModalActions = styled.div`
  padding: 12px 18px 18px 18px;
  display: flex;
  justify-content: center; /* ✅ center align delete button */
`;

const Button = styled.button`
  min-width: 200px;
  height: 48px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-weight: 600;
  cursor: pointer;
  &.danger {
    background: #F37A65;
    color: #fff;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const ActiveInitiativeCardWrapper = styled.div`
  width: ${({ fullWidth }) => fullWidth ? '100%' : 'calc((100% - 48px) / 3)'};
  min-width: 240px;
  background: #fff;
  border-radius: 8px;
  ${'' /* border: 1px solid #E8E8E8; */}
  border: 0.75px solid #DCDCDC;
  padding: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  
  .card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    .icon-wrap {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: ${({ color }) => color || '#BE7D9C'};
      ${'' /* border: 0.75px solid #E3B78E; */}
      ${'' /* border: ${({borderColor}) => borderColor ? `0.75px solid ${borderColor} ` : '0.75px solid #E3B78E'}  ; */}
      border: 0.75px solid ${({ color }) => darkenColor(color, 40)};
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      > img { width: 24px; height: 24px; }
    }
    .name {
      flex: 1;
      color: var(--Font-Color-on-Light-theme-500, #184A61);
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .bell-wrap {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      .badge {
        position: absolute;
        top: -8px;
        right: -8px;
        background: #F37A65;
        color: #fff;
        font-size: 10px;
        font-weight: 700;
        border-radius: 50%;
        min-width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 3px;
      }
    }
  }
  .type-badge {
    display: inline-flex;
    align-self: flex-start;
    margin: 8px 0 0 50px;
    background: #F0F6F8;
    color: #184A61;
    font-family: Lato;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    padding: 2px 10px;
  }
  .content-row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin: -12px -16px -16px -16px;
    ${'' /* padding: 24px 16px 16px 16px; */}
    padding: ${({isPadding}) => isPadding ? isPadding : '24px 16px 16px 16px'};

    border-radius: 0 0 8px 8px;
    .progress-wrap {
      flex-shrink: 0;
    }
    .stats {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 12px;
      .stat-row {
        display: flex;
        align-items: center;
        gap: 4px;
        .label {
          color: #184A61;
          font-family: Lato;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px;
          white-space: nowrap;
        }
        .colon {
          color: #184A61;
          font-family: Lato;
          font-size: 16px;
          font-weight: 700;
          line-height: 20px;
        }
        .val {
          color: #184A61;
          font-family: Lato;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
`;

const HealthMetricCardsWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`;

const HealthMetricCard = styled.div`
  flex: 1;
  border-radius: 12px;
  border: 0.75px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
  background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);
  padding: 16px 16px 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .card-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .card-title {
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  .info-icon {
    display: flex;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
  }

  .chart-area {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding-top: 8px;
  }

  .amount-area {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 20px 0;
  }

  .amount-value {
    color: #184A61;
    font-family: Lato;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
  }

  .amount-label {
    color: #649BB3;
    font-family: Lato;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
    margin-top: 4px;
  }
`;

export {
  NoInitiativeCard, CommonButton, Heading, InitiativesWrap, InitiativeCard, CheckMarkCount, HoverBackground, HdmTopCard, HeaderPopup, StyledModal,
  StyledModalBody, ParticipantsHeader,InitiativeImageContainer,  ScrollWrapper,InitiativeGraph, ParticipantCard,Backdrop, Button , ModalActions,ModalBody,Divider,ModalHeader,ModalCard,
  ActiveInitiativeCardWrapper, HealthMetricCardsWrapper, NewScheduledCard, HealthMetricCard
};
